import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { RewordConstant } from 'src/app/common/constants';
import { RewardFields } from '../reward-item.constant';
import { RewardService } from 'src/app/_services/reward.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';
import { MmitaAssetService } from 'src/app/_services/mmitaAsset.service';
import { InfiniteResult } from 'src/app/_models/body';
import { forkJoin } from 'rxjs';
import { Global } from 'src/app/_services/global.service';

@Component({
  selector: 'app-ant-reward-item',
  templateUrl: './ant-reward-item.component.html',
  styleUrls: ['./ant-reward-item.component.css']
})
export class AntRewardItemComponent implements OnInit {
  formGroup: FormGroup
  dialogFields
  callback
  readonly data: any
  readonly galleryAssets
  readonly preivewAssets
  readonly stripeCoupon
  readonly constantOptionDatas = {
    mapRewardType: RewordConstant.mapRewardType,
    coolDownIntervalType: RewordConstant.coolDownIntervalType,
    hosterType: RewordConstant.hosterType,
    rewardCollectionType: this.global.section.RewardCollectionTypeSelections,
  }
  unshowFieldLastTerm = []
  _assetList: Array<any> = []
  constructor(
    private rewardService: RewardService,
    private nzModalRef: NzModalRef,
    private assetService: MmitaAssetService,
    private global: Global
  ) { }

  ngOnInit(): void {
    this.genFG(this.data);

    const selectedIds = this.formGroup.get('rewardAssetIds').value;
    const hosterType = this.formGroup.get('hosterType').value;

    if (this.data && selectedIds?.length && hosterType !== 'MapPlace') {
      this.getAssetsByIds(selectedIds).subscribe(() => {
        this.setFormStatus(this.data);
      });
    } else {
      this.setFormStatus(this.data);
    }

    this.callback = () => this.onSubmit.call(this);
  }


  onSubmit() {
    return new Observable(sub => {
      const saveSuccess = () => {
        this.nzModalRef.triggerOk()
        sub.next()
        sub.complete()
      }
      this.data ? this.rewardService.update(this.formGroup.value, this.data.id).subscribe(res => {
        saveSuccess()
      }) : this.rewardService.addReward(this.formGroup.value).subscribe(res => {
        saveSuccess()
      })
    })

  }

  setFormStatus(fgData) {
    let assetList = []
    let unshowField = []
    let searchAssetByApi: boolean = false
    if (fgData?.hosterType === 'MapPlace') {
      assetList = this.galleryAssets
    } else {
      assetList = this._assetList
      searchAssetByApi = true
      unshowField = unshowField.concat(['ratioOnMap', 'isRefreshable', 'isRandomPoint'])
    }
    if (fgData?.mapRewardType !== 'Coupon') {
      unshowField.push('mmitaCouponIds')
    }
    if (!fgData?.isLimitMaxCollectedCount) {
      unshowField = unshowField.concat(['totalCollectableCount', 'alreadyCollectedCount'])
    }
    if (!fgData?.isRandomReward) {
      unshowField = unshowField.concat(['tokensRatio', 'mmitaCouponRatio'])
    }

    fgData?.mapRewardType === 'Asset' ? this.formGroup.get('rewardAssetIds').setValidators([Validators.required]) : this.formGroup.get('rewardAssetIds').setValidators(null)

    this.unshowFieldLastTerm.forEach(item => {
      this.formGroup.get(item).enable()
    })
    unshowField.forEach(item => {
      this.formGroup.get(item).disable()
    })
    this.unshowFieldLastTerm = unshowField
    this.dialogFields = RewardFields(this.constantOptionDatas, (ev) => this.getAsset(ev), this.preivewAssets, this.stripeCoupon, unshowField, fgData?.mapRewardType === 'Asset', assetList, searchAssetByApi)
  }

  genFG(orgData?) {
    this.formGroup = new FormGroup({
      description: new FormControl(orgData?.description),
      mapRewardType: new FormControl(orgData?.mapRewardType, Validators.required),
      ratioOnMap: new FormControl(orgData?.ratioOnMap),
      intervalCount: new FormControl(orgData?.intervalCount ?? 1, [Validators.required, Validators.min(1)]),
      coolDownIntervalType: new FormControl(orgData?.coolDownIntervalType, Validators.required),
      hosterType: new FormControl(orgData?.hosterType, Validators.required),
      previewAssetId: new FormControl(orgData?.previewAsset?.id, Validators.required),
      rewardAssetIds: new FormControl(orgData?.rewardAssetIds || []),
      numberOfTokens: new FormControl(orgData?.numberOfTokens, Validators.required),
      isRefreshable: new FormControl(orgData?.isRefreshable || false),
      isRandomPoint: new FormControl(orgData?.isRandomPoint || false),
      mmitaCouponIds: new FormControl(orgData?.mmitaCouponIds, Validators.required),
      isLimitMaxCollectedCount: new FormControl(orgData?.isLimitMaxCollectedCount || false),
      totalCollectableCount: new FormControl(orgData?.totalCollectableCount || 0, Validators.required),
      alreadyCollectedCount: new FormControl(orgData?.alreadyCollectedCount || 0, Validators.required),
      isRandomReward: new FormControl(orgData?.isRandomReward || false),
      tokensRatio: new FormControl(orgData?.tokensRatio, Validators.required),
      mmitaCouponRatio: new FormControl(orgData?.mmitaCouponRatio, Validators.required),
      rewardCollectionType: new FormControl(orgData?.rewardCollectionType || 'Normal', Validators.required),
      isNeedWhitelist: new FormControl(orgData?.isNeedWhitelist || false),      
    })
    orgData && this.formGroup.get('mapRewardType').disable()
    const watchField = ['hosterType', 'mapRewardType', 'isLimitMaxCollectedCount', 'isRandomReward']
    watchField.forEach(item => {
      this.formGroup.get(item).valueChanges.subscribe(res => {
        if (item === 'hosterType') {
          this.formGroup.get('rewardAssetIds').patchValue([])
          this._assetList = []
        }
        setTimeout(() => {
          this.setFormStatus(this.formGroup.value)
        })
      })
    })
  }

getAsset(value?) {
  return new Observable(subscriber => {
    if (!value) {
      // 没有搜索关键词，直接返回已有的 assetList
      subscriber.next(this._assetList);
      subscriber.complete();
      return;
    }

    const prop = { Name_Contains: value };
    this.assetService.getAll({ PageSize: '20', ...prop }).subscribe((res: InfiniteResult) => {
      const newAssets = res.data;

      // 获取当前已选中的 rewardAssetIds
      const selectedIds = this.formGroup.get('rewardAssetIds').value || [];
      const selectedAssets = this._assetList.filter(asset => selectedIds.includes(asset.id));

      // 合并已选项和新获取的 options，避免重复
      const mergedAssets = [...selectedAssets, ...newAssets.filter(asset => !selectedIds.includes(asset.id))];

      this._assetList = mergedAssets;
      subscriber.next(mergedAssets);
      subscriber.complete();
    });
  });
}



  getAssetsByIds(ids: string[]): Observable<any> {
    if (!ids || ids.length === 0) {
      return new Observable(sub => {
        sub.next([]);
        sub.complete();
      });
    }

    const requests = ids.map(id => this.assetService.getAll({ id }));

    return new Observable(subscriber => {
      forkJoin(requests).subscribe((results: InfiniteResult[]) => {
        const assets = results.reduce((acc, res) => acc.concat(res.data), []);
        const mergedAssets = [...assets, ...this._assetList.filter(asset => !ids.includes(asset.id))];
        this._assetList = mergedAssets;
        subscriber.next(mergedAssets);
        subscriber.complete();
      });
    });
  }





}
